export default __webpack_public_path__ + "static/media/traackr.0993f67b.svg";